module.exports = __webpack_public_path__ + "static/media/b1.15dcc1d0.svg";